import React from "react";
import NavBtn from "./nav-btns";

export default function Navbar({ fixed }) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between md:justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <a
              className="text-md font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase text-gray-900"
              href="/"
            >
              🌎 Safer Earth 
            </a>
            <button
              className="text-gray-900 cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center" +
              (navbarOpen ? " flex" : " hidden")
            }
            id="example-navbar-danger"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <NavBtn icon={"fas fa-donate"} name={"Donate"} routeName={"donate"} />
              <NavBtn icon={"fas fa-user-friends"} name={"About"} routeName={"about"} />
              <NavBtn icon={"fas fa-sign-in-alt"} name={"Login"} routeName={"signin"} />
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
